import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom';
import RegisterCustomerAccountFormStyle from './css/RegisterCustomerAccountFormStyle'
import { saveCustomer } from '../../CustomersAccountsFunctions'

function RegisterCustomerAccountForm(props) {
  const { cb, app, customerAccount } = props
  const customerAccountNameRef = useRef(null)
  const [keyPressed, setKeyPressed] = useState(false)
  let initCustomerAccountCustomerDetails =
    {
      account_name: '',
      present_address: '',
      contact_number: '',
      email: '',
      contact_persons_name: '',
      contact_persons_number:'',
      credit_limit: 0.00
    }

  initCustomerAccountCustomerDetails = customerAccount ? { ...initCustomerAccountCustomerDetails, ...customerAccount.customer_details } : initCustomerAccountCustomerDetails

  const [customerAccountCustomerDetails, setCustomerAccountCustomerDetails] = useState(initCustomerAccountCustomerDetails)

  const onClick = async (e) => {
    const lic = 'modal-window-footer'
    if (e.target.id === 'btn-save') {
      if (customerAccount) {
        await saveCustomer(app, { ...customerAccount, customer_details: customerAccountCustomerDetails }, lic)
      } else {
        await saveCustomer(app, { customer_details: customerAccountCustomerDetails, credit_accounts: [] }, lic)
      }
      cb('Save')
    }

    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
  }

  const onChange = (e) => {
    setKeyPressed(false) // reset
    if (!keyPressed) return
    setCustomerAccountCustomerDetails({ ...customerAccountCustomerDetails, [e.target.name]: e.target.value })
  }

  const onKeyDown = (e) => {
    // unwanted keys to avoid conflict with regular expression
    switch(e.key) {
      case '\\':
      case '*':
      case '+':
      case '[':
      case '(':
      case '?':
      case '$':
        setKeyPressed(false)
        break
      default:
        setKeyPressed(e.key)
    }
  }

  useEffect(() => { customerAccountNameRef.current.focus() }, [])

  return (
    <React.Fragment>
      <div className='form-container'>
        <div className='label-input-container'>
          <label>Account Name</label>
          <input
            type='text'
            id='account-name'
            name='account_name'
            className='top-anchor'
            ref={customerAccountNameRef}
            onChange={onChange}
            onKeyDown={onKeyDown}
            value={customerAccountCustomerDetails.account_name}
          />
        </div>
        <div className='label-input-container'>
          <label>Present Address</label>
          <input
            type='text'
            id='present-address'
            name='present_address'
            onChange={onChange}
            onKeyDown={onKeyDown}
            value={customerAccountCustomerDetails.present_address}
          />
        </div>
        <div className='label-input-container'>
          <label>Contact Number</label>
          <input
            type='text'
            id='contact-number'
            name='contact_number'
            onChange={onChange}
            onKeyDown={(e) => setKeyPressed(true)}
            value={customerAccountCustomerDetails.contact_number}
          />
        </div>
        <div className='label-input-container'>
          <label>Email</label>
          <input
            type='text'
            id='email'
            name='email'
            onChange={onChange}
            onKeyDown={onKeyDown}
            value={customerAccountCustomerDetails.email}
          />
        </div>
        <div className='label-input-container'>
          <label>Contact Person's Name</label>
          <input
            type='text'
            id='contact-persons-name'
            name='contact_persons_name'
            onChange={onChange}
            onKeyDown={onKeyDown}
            value={customerAccountCustomerDetails.contact_persons_name}
          />
        </div>
        <div className='label-input-container'>
          <label>Contact Person's Number</label>
          <input
            type='text'
            id='contact-persons-number'
            name='contact_persons_number'
            onChange={onChange}
            onKeyDown={(e) => setKeyPressed(true)}
            value={customerAccountCustomerDetails.contact_persons_number}
          />
        </div>
        <div className='label-input-container'>
          <label>Credit Limit</label>
          <input
            type='number'
            id='credit-limit'
            name='credit_limit'
            onChange={onChange}
            onKeyDown={onKeyDown}
            value={customerAccountCustomerDetails.credit_limit}
          />
        </div>
      </div>

      <div className='form-action-buttons-container'>
        <button
          id='btn-save'
          className='pospro-action-btn'
          onClick={onClick}
        >
        { customerAccount ? <>Update</> : <>Save</> }
        </button>
        <button
          id='btn-close'
          className='pospro-action-btn bottom-anchor'
          onClick={onClick}
        >
        Close
        </button>
      </div>
      <RegisterCustomerAccountFormStyle />
    </React.Fragment>
  )
}

export default React.memo(RegisterCustomerAccountForm)